import { useState, useRef, useEffect } from "react";
import { Send, Bot, User, Loader, RefreshCw } from "lucide-react";
import API from "../api";

export default function Chatbot() {
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Namaste! I'm Giri 🏔️ — your Uttarakhand travel buddy. Ask me anything about treks, temples, festivals, road conditions, packing, or hidden gems. Kya jaanna chahte ho?" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const bottomRef = useRef(null);

  useEffect(() => {
    API.get("/chatbot/suggestions")
      .then(r => setSuggestions(r.data.suggestions || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  const send = async (text) => {
    const msg = text || input.trim();
    if (!msg || loading) return;
    setInput("");

    const history = messages
      .filter(m => m.role !== "system")
      .map(m => ({ role: m.role, content: m.content }));

    setMessages(prev => [...prev, { role: "user", content: msg }]);
    setLoading(true);

    try {
      const res = await API.post("/chatbot/message", { message: msg, history });
      setMessages(prev => [...prev, { role: "assistant", content: res.data.reply }]);
    } catch {
      setMessages(prev => [...prev, {
        role: "assistant",
        content: "Sorry dost, I'm having trouble connecting. Try again in a moment! 🙏"
      }]);
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setMessages([{
      role: "assistant",
      content: "Namaste! I'm Giri 🏔️ — your Uttarakhand travel buddy. Ask me anything!"
    }]);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f0f4f0', display: 'flex', flexDirection: 'column', paddingBottom: 80 }}>
      {/* Header */}
      <div style={{ background: '#0a2a0a', padding: '20px 20px 20px', position: 'sticky', top: 0, zIndex: 10 }}>
        <div style={{ maxWidth: 600, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            {/* AI Avatar */}
            <div style={{
              width: 46, height: 46, borderRadius: 14,
              background: 'rgba(29,158,117,0.3)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 22
            }}>
              🏔️
            </div>
            <div>
              <p style={{ fontWeight: 700, color: 'white', fontSize: 16, margin: 0 }}>Giri AI</p>
              <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', margin: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#1D9E75', display: 'inline-block' }} />
                Uttarakhand travel expert
              </p>
            </div>
          </div>
          <button
            onClick={reset}
            style={{
              background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%',
              width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', color: 'rgba(255,255,255,0.7)', transition: 'background 0.2s'
            }}
          >
            <RefreshCw size={16} />
          </button>
        </div>
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '20px 16px', maxWidth: 600, margin: '0 auto', width: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: 16 }}>

        {/* Suggestions - show only at start */}
        {messages.length === 1 && suggestions.length > 0 && (
          <div style={{ margin: '8px 0 16px' }}>
            <p style={{ fontSize: 12, color: '#6b7280', textAlign: 'center', marginBottom: 12, fontWeight: 500 }}>
              Try asking about:
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
              {suggestions.map((s, i) => (
                <button
                  key={i}
                  onClick={() => send(s)}
                  style={{
                    background: 'white', border: '1px solid #1a3a1a', color: '#1a3a1a',
                    borderRadius: 999, padding: '8px 16px', fontSize: 13, fontWeight: 500,
                    cursor: 'pointer', transition: 'all 0.2s'
                  }}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}

        {messages.map((m, i) => (
          <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexDirection: m.role === "user" ? 'row-reverse' : 'row' }}>
            {/* Avatar */}
            <div style={{
              width: 32, height: 32, borderRadius: 10, flexShrink: 0, marginBottom: 2,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: m.role === "user" ? '#1a3a1a' : 'white',
              border: m.role === "user" ? 'none' : '1px solid rgba(0,0,0,0.08)'
            }}>
              {m.role === "user"
                ? <User size={15} style={{ color: 'white' }} />
                : <Bot size={15} style={{ color: '#1D9E75' }} />
              }
            </div>

            {/* Bubble */}
            <div style={{
              maxWidth: '80%',
              padding: '12px 16px',
              fontSize: 14,
              lineHeight: 1.6,
              ...(m.role === "user" ? {
                background: '#1a3a1a',
                color: 'white',
                borderRadius: '16px 16px 4px 16px',
              } : {
                background: 'white',
                color: '#1a2e1a',
                borderRadius: '16px 16px 16px 4px',
                border: '1px solid rgba(0,0,0,0.06)'
              })
            }}>
              {m.content}
            </div>
          </div>
        ))}

        {/* Loading indicator */}
        {loading && (
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end' }}>
            <div style={{
              width: 32, height: 32, borderRadius: 10, flexShrink: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'white', border: '1px solid rgba(0,0,0,0.08)'
            }}>
              <Bot size={15} style={{ color: '#1D9E75' }} />
            </div>
            <div style={{
              background: 'white', border: '1px solid rgba(0,0,0,0.06)',
              borderRadius: '16px 16px 16px 4px', padding: '12px 16px',
              display: 'flex', alignItems: 'center', gap: 4
            }}>
              {[0, 150, 300].map((delay, i) => (
                <span key={i} style={{
                  width: 7, height: 7, borderRadius: '50%', background: '#1D9E75',
                  opacity: 0.5 + i * 0.2,
                  animation: `bounce 1s ease-in-out ${delay}ms infinite`
                }} />
              ))}
            </div>
          </div>
        )}

        <div ref={bottomRef} />
      </div>

      {/* Input Bar */}
      <div style={{
        background: 'white', borderTop: '1px solid rgba(0,0,0,0.06)',
        padding: '12px 16px', position: 'sticky', bottom: 80, zIndex: 10
      }}>
        <div style={{ maxWidth: 600, margin: '0 auto', display: 'flex', gap: 10, alignItems: 'center' }}>
          <input
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && send()}
            placeholder="Ask Giri anything about Uttarakhand..."
            style={{
              flex: 1, background: 'white', border: '1px solid rgba(0,0,0,0.1)',
              borderRadius: 999, padding: '11px 18px', fontSize: 14, color: '#1a2e1a',
              outline: 'none', transition: 'border-color 0.2s'
            }}
            onFocus={e => { e.target.style.borderColor = '#1D9E75'; }}
            onBlur={e => { e.target.style.borderColor = 'rgba(0,0,0,0.1)'; }}
          />
          <button
            onClick={() => send()}
            disabled={loading || !input.trim()}
            style={{
              width: 42, height: 42, borderRadius: '50%', border: 'none', cursor: 'pointer',
              background: loading || !input.trim() ? '#9ca3af' : '#1D9E75',
              color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'background 0.2s', flexShrink: 0
            }}
          >
            {loading ? <Loader size={17} style={{ animation: 'spin 1s linear infinite' }} /> : <Send size={17} />}
          </button>
        </div>
      </div>
    </div>
  );
}
